var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../../../nunjucks.config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["front/utils/macros.jinja"] = require( "front/utils/macros.jinja" );
dependencies["submissions/components/SubmissionForm/SubmissionFormMembersItem.jinja"] = require( "submissions/components/SubmissionForm/SubmissionFormMembersItem.jinja" );




var shim = require("/var/www/django/adg.org/application/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["assets/app/submissions/components/SubmissionForm/SubmissionFormMembers.jinja"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("front/utils/macros.jinja", false, "assets/app/submissions/components/SubmissionForm/SubmissionFormMembers.jinja", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
context.setVariable("macros", t_1);
output += "\n\n";
env.getTemplate("submissions/components/SubmissionForm/SubmissionFormMembersItem.jinja", false, "assets/app/submissions/components/SubmissionForm/SubmissionFormMembers.jinja", false, function(t_5,t_4) {
if(t_5) { cb(t_5); return; }
t_4.getExported(function(t_6,t_4) {
if(t_6) { cb(t_6); return; }
if(Object.prototype.hasOwnProperty.call(t_4, "SubmissionFormMembersItem")) {
var t_7 = t_4.SubmissionFormMembersItem;
} else {
cb(new Error("cannot import 'SubmissionFormMembersItem'")); return;
}
context.setVariable("SubmissionFormMembersItem", t_7);
output += "\n\n\n";
var macro_t_8 = runtime.makeMacro(
[], 
["data"], 
function (kwargs) {
var callerFrame = frame;
frame = new runtime.Frame();
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
frame.set("data", Object.prototype.hasOwnProperty.call(kwargs, "data") ? kwargs["data"] : {});var t_9 = "";t_9 += "\n    <div class=\"SubmissionFormMembers\">\n\n        <div class=\"SubmissionFormMembers-wrapper-first\">\n            ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"team") && env.getFilter("length").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"team"))) {
t_9 += "\n                ";
frame = frame.push();
var t_12 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"team");
if(t_12) {t_12 = runtime.fromIterator(t_12);
var t_11 = t_12.length;
for(var t_10=0; t_10 < t_12.length; t_10++) {
var t_13 = t_12[t_10];
frame.set("item", t_13);
frame.set("loop.index", t_10 + 1);
frame.set("loop.index0", t_10);
frame.set("loop.revindex", t_11 - t_10);
frame.set("loop.revindex0", t_11 - t_10 - 1);
frame.set("loop.first", t_10 === 0);
frame.set("loop.last", t_10 === t_11 - 1);
frame.set("loop.length", t_11);
t_9 += "\n                    ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"first")) {
t_9 += "\n                        ";
t_9 += runtime.suppressValue((lineno = 12, colno = 50, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "SubmissionFormMembersItem"), "SubmissionFormMembersItem", context, [runtime.makeKeywordArgs({"data": t_13,"isRequired": true,"isHead": true})])), env.opts.autoescape);
t_9 += "\n                    ";
;
}
t_9 += "\n                ";
;
}
}
frame = frame.pop();
t_9 += "\n            ";
;
}
else {
t_9 += "\n                ";
t_9 += runtime.suppressValue((lineno = 16, colno = 42, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "SubmissionFormMembersItem"), "SubmissionFormMembersItem", context, [runtime.makeKeywordArgs({"data": {},"isRequired": true,"isHead": true})])), env.opts.autoescape);
t_9 += "\n            ";
;
}
t_9 += "\n        </div>\n\n        <div class=\"SubmissionFormMembers-wrapper\">\n            ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"team") && env.getFilter("length").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"team"))) {
t_9 += "\n                ";
frame = frame.push();
var t_16 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"team");
if(t_16) {t_16 = runtime.fromIterator(t_16);
var t_15 = t_16.length;
for(var t_14=0; t_14 < t_16.length; t_14++) {
var t_17 = t_16[t_14];
frame.set("item", t_17);
frame.set("loop.index", t_14 + 1);
frame.set("loop.index0", t_14);
frame.set("loop.revindex", t_15 - t_14);
frame.set("loop.revindex0", t_15 - t_14 - 1);
frame.set("loop.first", t_14 === 0);
frame.set("loop.last", t_14 === t_15 - 1);
frame.set("loop.length", t_15);
t_9 += "\n                    ";
if(!runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"first")) {
t_9 += "\n                        ";
t_9 += runtime.suppressValue((lineno = 24, colno = 50, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "SubmissionFormMembersItem"), "SubmissionFormMembersItem", context, [runtime.makeKeywordArgs({"data": t_17,"isRequired": false,"isHead": false})])), env.opts.autoescape);
t_9 += "\n                    ";
;
}
t_9 += "\n                ";
;
}
}
frame = frame.pop();
t_9 += "\n            ";
;
}
t_9 += "\n        </div>\n\n        <div class=\"SubmissionFormMembers-footer\">\n            <div class=\"SubmissionFormMembers-add\"><span>+</span><span>Add another team member</span></div>\n        </div>\n    </div>\n";
;
frame = callerFrame;
return new runtime.SafeString(t_9);
});
context.addExport("SubmissionFormMembers");
context.setVariable("SubmissionFormMembers", macro_t_8);
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["assets/app/submissions/components/SubmissionForm/SubmissionFormMembers.jinja"] , dependencies)


//////////////////
// WEBPACK FOOTER
// ./assets/app/submissions/components/SubmissionForm/SubmissionFormMembers.jinja
// module id = 59
// module chunks = 0